import "./index.css"
import "./mobile.css"

function Title(props) {
    return  <div className="title-holder">
    <img id="logo" src="./icons/logo.png" alt="MattBot logo"></img>
    <p id="beta-message">MattBot can make mistakes. Consider checking important information with me via my social media platform: <a target="_blank" rel="noreferrer" href="https://www.thegc.social">TheGC.</a></p>
  </div>  
  }

export default Title;
